import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { CycleTVO } from '../models/cycleTVO.model';

@Injectable({
  providedIn: 'root',
})
export class CycleTVODal {
  constructor(private http: HttpClient) {}

  getCyclesTVO(): Observable<any[]> {
    return this.http.get<any[]>(urlEndPoints.cycleTVO);
  }

  createCycleTVO(tvo: CycleTVO): Observable<any[]> {
    return this.http.post<any[]>(urlEndPoints.cycleTVO, tvo);
  }

  createCycleTVOFromSource(tvo: CycleTVO, originId: string): Observable<any[]> {
    return this.http.post<any[]>(urlEndPoints.cycleTVO + 'fromSource/' + `${originId}/`, tvo);
  }

  updateCycleTVO(cycleTVOId: string, tvo: CycleTVO): Observable<CycleTVO> {
    return this.http.put<CycleTVO>(urlEndPoints.cycleTVO + `?cycleTVOId=${cycleTVOId}`, {
      tvo,
    });
  }

  deleteCycleTVO(id: string): Observable<any[]> {
    return this.http.delete<any[]>(urlEndPoints.cycleTVO + `?tvoId=${id}`);
  }

  generateSO(option: any) {
    return this.http.post<any[]>(urlEndPoints.cycleTVO + 'generateSO', option);
  }

  copyWeek(tvo: string, from: number, to: number) {
    return this.http.post<any[]>(urlEndPoints.cycleTVO + 'copyWeek' + `?tvoId=${tvo}&source=${from}&target=${to}`, []);
  }

  copyFixNeeds(tvo: string, from: number, to: number) {
    return this.http.post<any[]>(
      urlEndPoints.cycleTVO + 'copyFixNeeds' + `?tvoId=${tvo}&source=${from}&target=${to}`,
      []
    );
  }

  updateCycleTVOComments(cycleTVOId: string, comments: string[]): Observable<CycleTVO> {
    return this.http.put<CycleTVO>(urlEndPoints.cycleTVO + `updateComments/?cycleTVOId=${cycleTVOId}`, {
      comments,
    });
  }
}
